module.exports = __webpack_public_path__ + "img/16_Detailhandelsfachmann_Foto.60f8fa03.jpg";